import TranslateIcon from '@mui/icons-material/Translate';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { useIntl } from 'react-intl';

/**
 * Checkbox that can be used to search for all languages.
 * @param {*} param0 
 * @returns 
 */
export default function LanguagesCheckbox({ initialValue, onChange, disabled = false, style = {} }) {
  const [checked, setChecked] = React.useState(initialValue);
  const intl = useIntl();

  return <div style={style}>
    <Tooltip
      title={intl.formatMessage({ id: "Attributes.allLanguages" })}
      placement="left"
      arrow
      style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
      <div>
        <Checkbox
          checked={checked}
          onChange={(event) => {
            setChecked(event.target.checked);
            onChange(event.target.checked);
          }}
          disabled={disabled}
        />
        <TranslateIcon />
      </div>
    </Tooltip>
  </div>

};